import { Sun, Moon, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const LABEL = { day: "rituale del giorno", night: "rituale della sera" };

const Option = ({ testid, icon: Icon, title, hint, onClick }) => (
  <button data-testid={testid} onClick={onClick}
    className="w-full text-left flex items-start gap-4 border border-[#E6DFD5] p-4 hover:border-[#C5A059] hover:bg-[#FDFBF8] transition-colors">
    <Icon size={18} strokeWidth={1.5} className="mt-0.5 text-[#8C6F3E] shrink-0" />
    <span><span className="block text-sm text-[#1A1A18]">{title}</span><span className="block text-xs text-[#8C8275] mt-0.5">{hint}</span></span>
  </button>
);

export const RemoveChoiceDialog = ({ open, product, moment, onChoose, onClose }) => {
  const other = moment === "day" ? "night" : "day";
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-[#FAF8F5] border-[#E6DFD5] rounded-none" data-testid="remove-choice-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-normal">Da dove vuoi toglierlo?</DialogTitle>
          <DialogDescription className="text-sm text-[#595652]">
            <span className="text-[#1A1A18]">{product?.name}</span> è presente sia nel rituale del giorno che in quello della sera. Resta nel carrello finché è in almeno uno dei due.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 mt-2">
          <Option testid="remove-choice-this" icon={moment === "day" ? Sun : Moon} title={`Solo dal ${LABEL[moment]}`} hint={`Resta nel ${LABEL[other]} e nel carrello`} onClick={() => onChoose([moment])} />
          <Option testid="remove-choice-other" icon={other === "day" ? Sun : Moon} title={`Solo dal ${LABEL[other]}`} hint={`Resta nel ${LABEL[moment]} e nel carrello`} onClick={() => onChoose([other])} />
          <Option testid="remove-choice-both" icon={Trash2} title="Da entrambi i rituali" hint="Viene tolto anche dal carrello" onClick={() => onChoose([moment, other])} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
